// extracted by mini-css-extract-plugin
module.exports = {"Page":"_locale__Page__XdO7Z","Page__wrapper":"_locale__Page__wrapper__HWjtw","Page__content":"_locale__Page__content__rLtSv","Page__new-appeal":"_locale__Page__new-appeal__0_APU"};